// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_exceptions from "../../../../../../../node_modules/rescript/lib/es6/caml_exceptions.js";

var Invalid_wallet_type = /* @__PURE__ */Caml_exceptions.create("WalletType.Invalid_wallet_type");

function fromString(type_) {
  switch (type_) {
    case "DEFAULT" :
        return /* Default */0;
    case "RECHARGE" :
        return /* Recharge */1;
    default:
      throw {
            RE_EXN_ID: Invalid_wallet_type,
            Error: new Error()
          };
  }
}

export {
  Invalid_wallet_type ,
  fromString ,
  
}
/* No side effect */
